import * as React from "react"
const JobopeningIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <g fill="none" stroke="#fff" strokeMiterlimit={10} strokeWidth={30}>
      <path
        d="M346 375H166c-16.569 0-30-13.431-30-30v-30h240v30c0 16.569-13.431 30-30 30zm-90 0v92m-105 30h15c23.431 0 36.569-30 60-30h60c23.431 0 36.569 30 60 30h15M31 225h15c16.569 0 30 13.431 30 30v30c0 16.569 13.431 30 30 30h30m345-90h-15c-16.569 0-30 13.431-30 30v30c0 16.569-13.431 30-30 30h-30m-.582-95.916-30-180C342.669 25.349 330.544 15 316 15H196c-14.583 0-26.733 10.404-29.438 24.192L136 225c0 16.569 13.431 30 30 30h180c16.569 0 30-13.431 30-30 0-2.025-.201-4.003-.582-5.916zM256 255v60"
        data-original="#000000"
        style={{
          strokeWidth: 30,
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="M226 105c0-16.569 13.431-30 30-30s30 13.431 30 30c0 11.533-6.507 21.545-16.051 26.566-9.081 4.779-13.949 14.988-13.949 25.249M241 195h30"
        data-original="#000000"
        style={{
          strokeWidth: 30,
          strokeMiterlimit: 10,
        }}
      />
    </g>
  </svg>
)
export default JobopeningIcon
